
      import Error from './error.vue'
      import type { App, Plugin } from 'vue'

      export const ErrorPlugin: Plugin = {
        install(app: App) {
          app.component('Error', Error)
        },
      }
      export { Error }
      